import { splitEvery } from 'ramda';
import { addItemsToStore } from 'reactApp/modules/uploading/helpers/cloudFs/addItemsToStore';
import { UploadingDescriptor } from 'reactApp/modules/uploading/serviceClasses/UploadingDescriptor';
import { uploadingService } from 'reactApp/modules/uploading/serviceClasses/UploadingService';
import { sendDescriptorsToUI } from 'reactApp/modules/uploading/uploading.module';
import { EProgressStatus, IInputFile } from 'reactApp/modules/uploadList/uploadList.model';
import { setInputFilesAction, setProgressStatusAction } from 'reactApp/modules/uploadList/uploadList.module';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { delay, put, select } from 'redux-saga/effects';

export function* handleSendDescriptorsToUI(action: ReturnType<typeof sendDescriptorsToUI>) {
    const BATCH_SIZE = 100;
    const DESCRIPTORS_TO_UI_BATCH_TIMEOUT = 250;

    const descriptors = splitEvery<UploadingDescriptor>(BATCH_SIZE, action.payload.descriptors);
    const fileDescriptors = splitEvery<IInputFile>(BATCH_SIZE, action.payload.fileDescriptors);

    const email = yield select(UserSelectors.getEmail);

    yield put(setProgressStatusAction({ status: EProgressStatus.PROGRESS }));

    let descriptorChunk = descriptors.shift();
    let fileInputChunk = fileDescriptors.shift();
    while (fileInputChunk || descriptorChunk) {
        if (uploadingService.isUserCanceled) {
            break;
        }

        fileInputChunk = fileInputChunk?.filter((item) => !uploadingService.getDescriptorById(item.descriptorId)?.hasCanceledParent());
        if (fileInputChunk?.length) {
            yield put(setInputFilesAction(fileInputChunk));
            // Особенно это важно для первого чанка, чтобы как можно быстрее отрисовать интерфейс
            yield delay(DESCRIPTORS_TO_UI_BATCH_TIMEOUT);
        }

        if (uploadingService.isUserCanceled) {
            break;
        }

        descriptorChunk = descriptorChunk?.filter((descriptor) => !descriptor.hasCanceledParent());
        if (descriptorChunk?.length) {
            yield processAddToStoreChunk(descriptorChunk, email);
            yield delay(DESCRIPTORS_TO_UI_BATCH_TIMEOUT);
        }

        descriptorChunk = descriptors.shift();
        fileInputChunk = fileDescriptors.shift();
    }

    uploadingService.stopProcessing(action.payload.processingId);
}

function* processAddToStoreChunk(descriptors: UploadingDescriptor[], email: string) {
    yield addItemsToStore({
        email,
        files: descriptors,
        skipItemStoreUpdate: true,
    });
}
